import React from "react";
import ReactDOM from "react-dom/client";
import { UserContextProvider } from "./contexts/userContext";
import { BrowserRouter} from "react-router-dom";
import App from './App'
import './styles/shared/main.css'

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserContextProvider>
      <BrowserRouter>
      <App/>
      </BrowserRouter>
    </UserContextProvider>
  </React.StrictMode>
);
